import { Link } from "react-router-dom";
import WebLayout from "../layout/WebLayout";
import { RACK_IMAGE, SHELF_IMAGE } from "../utils/Constants";

function Franchise() {
  return (
    <WebLayout pageName="Franchise">
      <div className="container mx-auto px-4 py-8">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8 mb-12 text-center">
          <h1 className="text-4xl font-bold text-indigo-800 mb-4">
            IndianMSME.org Branding Display Scheme
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Empowering MSME manufacturers with direct consumer access at 1200+
            Ardh Sainik Canteens or Ardh Sainik Malls across India.
          </p>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden mb-12">
          <div className="p-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
              "Makers to Market" Initiative
            </h2>

            <p className="text-gray-600 mb-8 leading-relaxed">
              The IndianMSME.org Branding Display Scheme is designed to empower
              MSME (Micro, Small, and Medium Enterprises) manufacturers by
              providing a platform to showcase their products directly to
              consumers at 1200 Ardh Sainik Canteens or Ardh Sainik Malls across
              India. This initiative facilitates cost-effective branding and
              product visibility.
            </p>

            <div className="row mb-12">
              {/* Rack Branding */}
              <div className="col-md-6 bg-gray-50 p-10 rounded-lg border border-gray-200">
                <div className="flex justify-center mb-4">
                  <img
                    src={RACK_IMAGE}
                    alt="Rack Display"
                    className="rounded-lg shadow-sm max-h-48 object-cover"
                  />
                </div>
                <h3 className="text-xl font-semibold text-indigo-700 mb-10">
                  Rack Branding
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start mb-5">
                    <span className="text-gray-700">
                      Size: 3 x 6 feet rack with 5 shelves
                    </span>
                  </li>
                  <li className="flex items-start mb-5">
                    <span className="text-gray-700">
                      Inclusions: One banner flex (2 x 3 feet)
                    </span>
                  </li>
                  <li className="flex items-start mb-5">
                    <span className="text-gray-700">
                      Charge: ₹2000/- per month for one full rack
                    </span>
                  </li>
                </ul>
              </div>

              {/* Shelf Branding */}
              <div className="col-md-6 bg-gray-50 p-10 rounded-lg border border-gray-200">
                <div className="flex justify-center mb-4">
                  <img
                    src={SHELF_IMAGE}
                    alt="Shelf Display"
                    className="rounded-lg shadow-sm max-h-48 object-cover"
                  />
                </div>
                <h3 className="text-xl font-semibold text-indigo-700 mb-10">
                  Shelf Branding
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start mb-5">
                    <span className="text-gray-700">
                      Size: Individual shelf
                    </span>
                  </li>
                  <li className="flex items-start mb-5">
                    <span className="text-gray-700">
                      Inclusions: One banner flex (2 x 3 feet)
                    </span>
                  </li>
                  <li className="flex items-start mb-5">
                    <span className="text-gray-700">
                      Charge: ₹500/- per month per shelf
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Benefits Section */}
            <div className="bg-indigo-50 rounded-lg p-8">
              <h2 className="text-2xl font-semibold text-indigo-800 mb-6 text-center">
                Key Benefits for MSME Manufacturers
              </h2>
              <ul className="list-inside mt-10 ms-16">
                <li className="text-gray-400 mb-4">
                  Enhanced visibility in high-traffic areas.
                </li>
                <li className="text-gray-400 mb-4">
                  Direct exposure to a large consumer base in Ardh Sainik.
                  outlets
                </li>
                <li className="text-gray-400 mb-4">
                  Affordable branding rates tailored to MSMEs.
                </li>
              </ul>
            </div>

            {/* CTA Section */}
            <div className="mt-12 text-center">
              <p className="text-gray-600 mb-6 max-w-2xl mx-auto leading-relaxed">
                This initiative aims to bridge the gap between "makers" and
                "markets" by offering accessible, localized advertising
                opportunities for MSMEs.
              </p>
              <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-8 rounded-lg shadow-md transition duration-300">
                Enquire Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default Franchise;
